export const state = {
  isCollapsed: false,
  isShowWidget: false,
  calls: [],
  isMuted: false,
  voipState: {},
}

export const getters = {
  vehicleIdsCallActive: (state) => {
    return state.calls.map((call) => call.vehicleId)
  },
  sumCallsActive: (state) => {
    return state.calls.length
  },
}

export const actions = {
  startNewCall(
    { commit },
    {
      dataNewCall: { vehicleId, licensePlate, driver, imei, deviceType, entryPoint },
      isAutoReconnect = false,
    }
  ) {
    commit('addCalls', { vehicleId, licensePlate, driver, imei, deviceType, entryPoint })
    if (isAutoReconnect) return
    let callsActive
    if (!window.localStorage.getItem('voipActive')) {
      callsActive = []
    } else {
      callsActive = JSON.parse(window.localStorage.getItem('voipActive'))
    }

    const mergedCalls = [
      ...callsActive,
      { vehicleId, licensePlate, driver: driver ?? null, imei, deviceType },
    ]
    window.localStorage.setItem('voipActive', JSON.stringify(mergedCalls))
  },

  endCall({ commit }, { vehicleId }) {
    commit('removeCalls', vehicleId)
    commit('deleteVoipState', vehicleId)
    const callsActive = JSON.parse(window.localStorage.getItem('voipActive'))
    window.localStorage.setItem(
      'voipActive',
      JSON.stringify(callsActive.filter((call) => call.vehicleId !== vehicleId))
    )
  },

  endCallAll({ commit }) {
    commit('resetVoipState')
    commit('removeAllCalls')
    window.localStorage.setItem('voipActive', JSON.stringify([]))
  },
}

export const mutations = {
  setIsCollapsed(state, payload) {
    state.isCollapsed = payload
  },
  setIsShowWidget(state, payload) {
    state.isShowWidget = payload
  },
  /**
   *
   * @param {*}  vehicleId
   * @param {*}  licensePlate
   * @param {*}  driver
   * @param {*}  imei
   * @param {*}  deviceType
   * @param {*}  entryPoint | 'modalDetailVehicle' | 'floatingMap' | 'alertCenter' | 'detailNotification' | 'controlTower' | 'mediaPlayerStreaming'
   */
  addCalls(state, { vehicleId, licensePlate, driver, imei, deviceType, entryPoint }) {
    const tempCalls = [
      ...state.calls,
      { vehicleId, licensePlate, driver, imei, deviceType, entryPoint },
    ]
    state.calls = tempCalls
  },
  removeCalls(state, vehicleId) {
    const tempCalls = state.calls.filter((call) => vehicleId !== call.vehicleId)
    state.calls = tempCalls
  },
  removeAllCalls(state) {
    state.calls = []
  },
  toggleMuted(state) {
    state.isMuted = !state.isMuted
  },
  setIsMuted(state, payload) {
    state.isMuted = payload
  },
  setVoipState(state, { vehicleId, values }) {
    const tempState = Object.assign({}, state.voipState)
    tempState[vehicleId] = values
    state.voipState = tempState
  },

  deleteVoipState(state, vehicleId) {
    const tempState = Object.assign({}, state.voipState)
    delete tempState[vehicleId]
    state.voipState = tempState
  },

  resetVoipState(state) {
    state.voipState = {}
  },
}
